var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2634_2436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.181641C14.2266 0.181641 17.25 3.21028 17.25 6.94641V9.20133H18C19.6547 9.20133 21 10.5496 21 12.2079V21.2276C21 22.8859 19.6547 24.2342 18 24.2342H3C1.34297 24.2342 0 22.8859 0 21.2276V12.2079C0 10.5496 1.34297 9.20133 3 9.20133H3.75V6.94641C3.75 3.21028 6.77344 0.181641 10.5 0.181641ZM10.5 3.18821C8.42813 3.18821 6.75 4.87094 6.75 6.94641V9.20133H14.25V6.94641C14.25 4.87094 12.5719 3.18821 10.5 3.18821ZM12 15.2145C12 14.383 11.3297 13.7112 10.5 13.7112C9.67031 13.7112 9 14.383 9 15.2145V18.221C9 19.0525 9.67031 19.7243 10.5 19.7243C11.3297 19.7243 12 19.0525 12 18.221V15.2145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2634_2436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24.0525,
    fill: "white",
    transform: "translate(0 0.181641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.04ad8dea61d3695bd8c1a4984bbd4211.svg";
export { ForwardRef as ReactComponent };